module.exports = __webpack_public_path__ + "assets/img/36_1502_big.0034e7a1.jpg";